import React, { useState } from "react";
import { forgotPassword } from "../../../api/UserAPIUtils";
import AuthShell from "./AuthShell";

interface ForgottenPasswordWindowProps {
  setWindow: React.Dispatch<
    React.SetStateAction<"login" | "forgottenPassword" | "changePassword">
  >;
}

const ForgottenPasswordWindow: React.FC<ForgottenPasswordWindowProps> = ({
  setWindow,
}) => {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [emailSent, setEmailSent] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (emailSent) {
      setEmail("");
      setEmailSent(false);
      setWindow("login");
    } else {
      const response = await forgotPassword(email);
      if (response.success) {
        setEmailSent(true);
        setError("");
      } else {
        setError(response.message);
      }
    }
  };
  const handleReturnToLogin = () => {
    setWindow("login");
  };

  return (
    <AuthShell
      eyebrow="Account recovery"
      title={emailSent ? "Email sent" : "Forgot password?"}
      description={
        emailSent
          ? "Check your inbox for a password reset link, then return to login once you're ready."
          : "Enter your email address and we'll send you instructions to reset your password."
      }
    >
      <form onSubmit={handleSubmit} className="space-y-5">
        {!emailSent ? (
          <div>
            <label className="mb-2 block text-[11px] font-bold uppercase tracking-[0.22em] text-slate-700">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="h-14 w-full rounded-[20px] border border-slate-200 bg-white px-5 text-base text-slate-700 outline-none transition focus:border-primary focus:ring-2 focus:ring-primary/15"
              placeholder="Enter your email"
            />
          </div>
        ) : null}

        {error ? <p className="text-sm text-red-500">{error}</p> : null}

        <button
          type="submit"
          disabled={loading}
          className="inline-flex h-14 w-full items-center justify-center rounded-full bg-primary px-6 text-base font-semibold text-white shadow-[0_12px_24px_rgba(0,128,128,0.2)] transition hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {emailSent ? "Return to Login" : loading ? "Sending..." : "Confirm"}
        </button>
      </form>

      {!emailSent ? (
        <button
          type="button"
          className="mt-5 text-sm font-semibold text-primary transition hover:opacity-80"
          onClick={handleReturnToLogin}
        >
          Return to Login
        </button>
      ) : null}
    </AuthShell>
  );
};

export default ForgottenPasswordWindow;
